import * as Preact from "preact"
import Pointer from "poin"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

import "@frog/source/views/Mount.less"
import Stage from "@frog/source/views/Stage.jsx"
import DevPanes from "@frog/source/views/DevPanes.jsx"
import ChapterUI from "@frog/source/views/ChapterUI.jsx"
import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import Snow from "@frog/source/views/components/Snow.jsx"

import Resize from "@frog/source/utility/Resize.js"
import Preload from "@frog/source/utility/Preload.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

import tests from "@frog/source/tests/testlist.js"
import audios from "@frog/source/data/audiotriggers.js"
import units from "@frog/source/data/units.js"
import games from "@frog/source/data/games"

export default class Mount {
    render() {
        return (
            <div class="Mount" isDev={Dev.areDevPanelsOpen || false}>
                <DevPanes>
                    <div class="FrameSection">
                        <Frame>
                            <Screen/>
                        </Frame>
                    </div>
                </DevPanes>
            </div>
        )
    }
}

class Frame {
    render() {
        return (
            <div class="Frame" id="frame" onContextMenu={this.onContextMenu}>
                {this.props.children}
            </div>
        )
    }
    componentDidMount() {
        Resize({
            "width": 16,
            "height": 9,
            "domId": "frame"
        })

        const element = document.getElementById("frame")
        Pointer.listen(element)
    }
    componentDidUpdate() {
        Resize()
    }
    onContextMenu(event) {
        event.preventDefault()
    }
}

class Screen {
    render() {
        if(Preload.isLoading) {
            const Screen = SCREENS["LoadingScreen"]
            return <Screen/>
        }

        const screenName = Navigation.state.screen
        const Screen = SCREENS[screenName]

        if(Screen != undefined) {
            return <Screen/>
        } else {
            const ErrorScreen = SCREENS["ErrorScreen"]
            return <ErrorScreen message={"Could not find screen: " + screenName}/>
        }
    }
}

const SCREENS = {
    "LoadingScreen": function() {
        return (
            <div class="LoadingScreen">
                <div class="ProgressBar" style={{"width": (Preload.loadedImageCount / Object.values(Preload.images).length) * 100 + "%"}}/>
                <div class="Header Text">Loading...</div>
                <div class="Base Text">Loading...</div>
            </div>
        )
    },
    "TitleScreen": function() {
        return (
            <div class="TitleScreen">
                <div class="Splash" isSplashing={Navigation.state.isSplashing + ""}
                    onClick={() => Navigation.state.isSplashing = false}>
                    <div class="Logo1">goodberry games</div>
                    <div class="Logo2">made with frog</div>
                </div>
                <div class="Main">
                    {(TITLE_CONTENTS[Navigation.state.gameSlug] || TITLE_CONTENTS["default"])()}
                    <div class="DevHellButton" onClick={() => Navigation.go("/dev")}>Dev Hell</div>
                </div>
            </div>
        )
    },
    "ChapterSelectScreen": function() {
        return (
            <div class="ChapterSelectScreen">
                TODO: Put a world map, with clickable spots for each chapter.
            </div>
        )
    },
    "ChapterScreen": function() {
        if(App.game == undefined) return
        let stage = App.getActiveStage()
        if(Dev.inProtoMode == true) {
            stage = games[App.game.slug].chapters[App.game.chapter.slug].stage
        }
        return (
            <div class="ChapterScreen"
                onMouseDown={(event) => App.game.chapter.selection.start()}
                onMouseUp={(event) => App.game.chapter.selection.finish()}
                onContextMenu={(event) => App.game.chapter.selection.cancel()}>
                <Stage stage={stage}/>
                <ChapterUI stage={stage}/>
                <Snow stage={stage}/>
            </div>
        )
    },
    "CreditsScreen": function() {
        return (
            <div class="CreditsScreen">
                <div class="Content">
                    <div class="Title">
                        <span>Diehorde</span>
                    </div>
                    <div class="Credits">
                        A seven day roguelike by Andrew Goodenough and Doc McPherson
                    </div>
                    <div class="Thanks" onMouseDown={() => Navigation.go("/games/hell")}>
                        Thanks for playing!!
                    </div>
                </div>
            </div>
        )
    },
    "ErrorScreen": function({message}) {
        return (
            <div class="ErrorScreen">
                {Navigation.state.message || message || "Something went wrong."}
            </div>
        )
    },
    "DevHellScreen": function() {
        return (
            <div class="DevHellScreen">
                <div class="Header">Welcome to Dev Hell</div>
                <div class="Links">
                    <div class="Link" onClick={() => Navigation.go("/dev/tests")} result="">Tests</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/audio")}>Audio</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/units")}>Units</div>
                    <div class="Link" onClick={() => Navigation.go("/dev/chapters")}>Chapters</div>
                </div>
            </div>
        )
    },
    "DevTestListScreen": function() {
        return (
            <div class="DevTestListScreen">
                <div class="Header">Tests</div>
                <div class="Tests">
                    {tests.map((test) => {
                        return (
                            <div class="Test" status={test.status || "loading"}
                                onClick={() => Navigation.go("/dev/tests/" + test.slug)}/>
                        )
                    })}
                </div>
            </div>
        )
    },
    "DevTestScreen": function() {
        return (
            <div class="DevTestScreen" status={Navigation.state.test.status}>
                <div class="TestSlug">{Navigation.state.test.slug}</div>
                <div class="Message">{Navigation.state.test?.error?.message}</div>
            </div>
        )
    },
    "DevAudioListScreen": function() {
        return (
            <div class="DevAudioListScreen">
                <div class="Header">Audio</div>
                <div class="Audios">
                    {Object.keys(audios).map((audiokey) => {
                        return (
                            <div class="Audio" onClick={() => Audiomix.killall() + Audiomix.trigger(audiokey)}>
                                {audiokey}
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    },
    "DevChapterListScreen": function() {
        return (
          <div class="DevChapterListScreen">
              <div class="Header">Chapters</div>
              <div class="Chapters">
                  {Object.values(games[App.game.slug].chapters).map((chapter) => {
                      return (
                          <div class="Chapter" onClick={() => Navigation.go("/game/chapters/"+chapter.slug)}>
                              {chapter.slug}
                          </div>
                      )
                  })}
              </div>
          </div>
        )
    },
    "DevUnitListScreen": function() {
        return (
            <div class="DevUnitListScreen">
                <div class="Header">Units</div>
                <div class="Unit">
                    <div class="Image Column"/>
                    <div class="Name Column">Name</div>
                    <div class="Number Column">HP</div>
                    <div class="Number Column">PW</div>
                    <div class="Number Column">MR</div>
                    <div class="Number Column">AR</div>
                    <div class="String Column">Type</div>
                    <div class="String Column">Element</div>
                </div>
                <div class="Units">
                    {Object.values(units).map((unit) => {
                        return (
                            <div class="Unit">
                                <div class="Image Column">
                                    <UnitSprite unit={unit}/>
                                </div>
                                <div class="Name Column">{unit.jobName}</div>
                                <div class="Number Column">{unit.maxhealth}</div>
                                <div class="Number Column">{unit.power}</div>
                                <div class="Number Column">{unit.moverange}</div>
                                <div class="Number Column">{unit.attackrange}</div>
                                <div class="String Column">{unit.attacktype}</div>
                                <div class="String Column">{unit.element}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    },
}

const TITLE_CONTENTS = {
    "hell": function() {
        return (
            <div class="Hell TitleContents">
                <div class="Button" isShaky={true} onClick={() => Navigation.go("/games/hell/chapters/wrath")}>Ready</div>
            </div>
        )
    },
    "default": function() {
        const game = games[Navigation.state.gameSlug]
        if(game == undefined) return
        return (
            <div class="Default TitleContents">
                <div class="Title">{game.title || game.slug}</div>
                <div class="Button" onClick={() => Navigation.go("/games/" + game.slug + "/chapters/" + (game.firstChapterKey || "1"))}>Play!!</div>
            </div>
        )
    }
}
